import React from 'react';

import WangEditor from '../../../../components/WangEditor';
import { QuestionItem } from '../../types';

import './index.less';

interface IProps {
  firstIndex: number;
  secondIndex: number;
  myAnswer: string | string[];
  questionItem: QuestionItem;
  handleAnswer: (firstIndex: number, secondIndex: number, questionItem: QuestionItem) => void;
}

function AnswerOption({firstIndex, secondIndex, myAnswer, questionItem, handleAnswer }: IProps) {

  function saveEditor(value: string) {
    console.log(value);
  }

  function onBlurEditor(value: string) {
    // 失去焦点后拿到值
    let newData = {...questionItem};
    newData.myAnswer = value;
    handleAnswer(firstIndex, secondIndex, newData);
  }

  return (
    <div className="text-answer-option">
      <WangEditor initData={myAnswer} onBlurEditor={onBlurEditor} />
    </div>
  )
}

export default AnswerOption;
